export const divmod = (value, lambda) => [Math.floor(value / lambda), value % lambda];

export const truncateExtraDecimals = (num, numOfDecimals = 0) => {
    const idx = num.toString().indexOf('.');
    return idx >= 0
        ? Number(num.toString().slice(0, idx + numOfDecimals + 1))
        : num;
};
